import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TextsProvider } from './contexts/TextsContext';
import { DataProvider } from './contexts/DataContext';
import './index.css';
import App from './components/app/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const basename = import.meta.env.VITE_BASENAME;

root.render(
    <TextsProvider>
        <DataProvider>
            <BrowserRouter basename={basename}>
                <App />
            </BrowserRouter>
        </DataProvider>
    </TextsProvider>
);
